(function() {
  for (let i = 0; i < 3; i++) {
    const pumper_price = window[`pumper_prices_${ i }`];
    const pumper_price_block = document.querySelector(`.prvw__quantity_label${i+1}`);

    if(pumper_price && pumper_price_block) {
      const pumper_price_element = pumper_price_block.querySelector(`#prvw_totalAmount_${i}`);
      const pumper_compare_price_element = pumper_price_block.querySelector(`#prvw_originalAmount_${i}`);
      const pumper_discount_element = pumper_price_block.querySelector(`.template_4_block__cbmain--content--left__top h4`);

      pumper_price_element.innerHTML = pumper_price.price;

      if(pumper_price.compare_price) {
        pumper_compare_price_element.innerHTML = pumper_price.compare_price;

        if(pumper_discount_element) {
          pumper_discount_element.innerHTML = pumper_price.discount;
        } else {
          const pumper_discount_wrapper = pumper_price_block.querySelector(`.template_4_block__cbmain--content--left__top`);

          pumper_discount_wrapper.insertAdjacentHTML('beforeend', `<h4 style="color: #ffffff;background-color: #0054FF;border-radius: 6px;font-size: 14px;font-weight: 600;font-style: normal;">${pumper_price.discount}</h4>`);
        }
      } else {
        pumper_compare_price_element?.remove();
        pumper_discount_element?.remove();
      }
    }
  }
})();
